import { SendAppDataParams, SendAppEventParams } from '@/shared/api/rest/types'

const iosDeviceMapping = new Map([
    // --- Старые iPhone ---
    ['320x480', 'iPhone 1st gen, 3G, 3GS, 4, 4S'],
    ['320x568', 'iPhone 5, 5c, 5s, SE (1st gen)'],

    // --- iPhone 6 / 7 / 8 / SE 2/3 ---
    ['375x667', 'iPhone 6, 6s, 7, 8, SE (2nd/3rd gen)'],
    ['414x736', 'iPhone 6 Plus, 6s Plus, 7 Plus, 8 Plus'],

    // --- Безрамочные до 13 mini ---
    ['375x812', 'iPhone X, XS, 11 Pro, 12 mini, 13 mini'],
    ['414x896', 'iPhone XR, 11, XS Max, 11 Pro Max'],

    // --- 12 / 13 / 14 / 16e (обычные) ---
    ['390x844', 'iPhone 12, 12 Pro, 13, 13 Pro, 14, 16e'],

    // --- Большие 12/13/14 ---
    ['428x926', 'iPhone 12 Pro Max, 13 Pro Max, 14 Plus'],

    // --- Dynamic Island 14 Pro / 15 / 16 ---
    ['393x852', 'iPhone 14 Pro, 15, 15 Pro, 16'],

    // --- Pro Max / Plus (14–16) ---
    ['430x932', 'iPhone 14 Pro Max, 15 Plus, 15 Pro Max, 16 Plus'],

    // --- 16 / 17 Pro-линейка ---
    ['402x874', 'iPhone 16 Pro, 17, 17 Pro'],
    ['440x956', 'iPhone 16 Pro Max, 17 Pro Max'],

    // --- Air / 17 Air ---
    ['420x912', 'iPhone Air, iPhone 17 Air'],

    // ======================
    //         iPad
    // ======================

    // --- iPad mini ---
    ['744x1133', 'iPad mini (6th gen, 7th gen)'],

    // --- Классический 9.7" / mini старые ---
    [
        '768x1024',
        'iPad (1st–6th gen), iPad mini (1st–5th gen), ' +
            'iPad Air (1st–2nd gen), iPad Pro 9.7"',
    ],

    // --- Бюджетные iPad 10.2"/10.9" ---
    ['810x1080', 'iPad (7th–11th gen)'],

    // --- Air / iPad 10-го поколения / Air 11" (6th) ---
    ['820x1180', 'iPad Air (4th–6th gen 11"), iPad 10th gen'],

    // --- Pro 10.5" / Air 3 ---
    ['834x1112', 'iPad Pro 10.5", iPad Air (3rd gen)'],

    // --- Pro 11" до M4 ---
    ['834x1194', 'iPad Pro 11" (1st–6th gen)'],

    // --- Pro 11" (M4, 2024) ---
    ['834x1210', 'iPad Pro 11" (7th gen, 2024, M4)'],

    // --- Pro 12.9" + Air 13" ---
    ['1024x1366', 'iPad Pro 12.9" (1st–6th gen), iPad Air 13" (6th gen)'],

    // --- Pro 13" (M4, 2024) ---
    ['1032x1376', 'iPad Pro 13" (7th gen, 2024, M4)'],
])
const desktopDeviceMapping = new Map([
    ['Win32', 'Windows'],
    ['Linux', 'Linux'],
    ['MacIntel', 'Mac OS'],
])

// get device name for android
const getAndroidDeviceName = () => {
    const androidUserAgentString = window.navigator.userAgent.slice(
        window.navigator.userAgent.indexOf('Android')
    )
    const androidDeviceName = androidUserAgentString.slice(
        androidUserAgentString.indexOf('; ') + 1,
        androidUserAgentString.indexOf(')')
    )
    if (androidDeviceName) {
        return androidDeviceName.trim().split(' ')[0]
    }

    return 'Android'
}

// get device name for ios
const getIosDeviceName = () => {
    const screenResolution = `${window.screen.width}x${window.screen.height}`
    const device = iosDeviceMapping.get(screenResolution)
    if (device) {
        return device
    }
    return 'Iphone'
}

// get device name for desktop
const getDesktopDeviceName = () => {
    const platform =
        //@ts-expect-error //skip
        navigator?.userAgentData?.platform || navigator?.platform || 'unknown'
    return desktopDeviceMapping.get(platform) ?? 'Unknown'
}

// get device name utility
export default function getDeviceName(): string {
    let device = ''
    const isMobileDevice = window.navigator.userAgent
        .toLowerCase()
        .includes('mobi')

    if (isMobileDevice) {
        if (window.navigator.userAgent.includes('Android')) {
            device = getAndroidDeviceName()
        } else {
            device = getIosDeviceName()
        }
    } else {
        device = getDesktopDeviceName()
    }

    return device
}

function randomUUID() {
    const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'

    return template.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8

        return v.toString(16)
    })
}

function getDeviceId(): string {
    if (!localStorage.getItem('deviceId')) {
        localStorage.setItem('deviceId', randomUUID())
    }

    return localStorage.getItem('deviceId')!
}

function getDeviceData() {
    const resolution = `${screen.width}x${screen.height}`
    const ua = navigator.userAgent

    const os = (() => {
        const l = ua.toLowerCase()
        if (/android/.test(l)) return 'android'
        if (/iphone|ipad|ipod/.test(l)) return 'ios'
        if (/win/.test(l)) return 'windows'
        if (/mac/.test(l)) return 'macos'
        if (/linux/.test(l)) return 'linux'
        return 'unknown'
    })()

    const model = getDeviceName()

    return { os, model, resolution }
}

function getSessionId() {
    return localStorage.getItem('sessionId')
}

export function getData(
    payload?: Record<string, unknown>
): SendAppDataParams | SendAppEventParams {
    return {
        deviceId: getDeviceId(),
        sessionId: getSessionId()!,
        createdAt: new Date().toISOString(),
        link: window.location.href,
        data: {
            device: getDeviceData(),
            version: process.env.VUE_APP_BUILD_VERSION,
            ...payload,
        },
    }
}
